module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/brand/high-five-brand-441068d2c1138b01305f91860705a531.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/brand/high-five-brand.svg
// module id = KNJx
// module chunks = 24